import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ModalDialogMUI6 from 'src/components/ModalDialogMUI6';
import TelnyxMigrationPinForm from 'src/components/TelnyxMigrationPin/TelnyxMigrationPinForm';
import COPY from 'src/components/TelnyxMigrationPin/copy';
import { addNotification } from 'src/actions/notificationActions';
import { NOTIFICATION_STATUS, ROUTES } from 'src/constants';
import {
  readPinRemindLater,
  writePinRemindLater,
  clearPinRemindLater,
} from 'src/helpers/telnyxMigrationPin';

// Texting-move code prompt. Opens on whatever page the consultant lands on
// after sign-in when the login payload says a code is required
// (account.telnyxMigrationPin.required). It cannot be dismissed for good:
// "Remind me later" hides it for this browser session only, and it comes
// back on the next sign-in in a new tab until the code is entered, or when
// she clicks "Enter code" in the top banner (telnyxMigrationPinModalRequest).
//
// Closes on its own once the code is verified (or the server says there is
// nothing to do) because the verify/status thunks clear
// account.telnyxMigrationPin.
function TelnyxMigrationPinModal() {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    user,
    telnyxMigrationPin,
    telnyxMigrationPinModalRequest,
  } = useSelector((state) => state.account) || {};
  const userId = user?.id;

  const [remindLater, setRemindLater] = useState(() => readPinRemindLater(userId));

  useEffect(() => {
    setRemindLater(readPinRemindLater(userId));
  }, [userId]);

  useEffect(() => {
    if (!telnyxMigrationPinModalRequest) {
      return;
    }
    clearPinRemindLater(userId);
    setRemindLater(false);
  }, [telnyxMigrationPinModalRequest, userId]);

  const handleRemindLater = useCallback(() => {
    writePinRemindLater(userId);
    setRemindLater(true);
  }, [userId]);

  const handleVerified = useCallback(() => {
    dispatch(addNotification(
      'telnyxMigrationPinVerified',
      COPY.success,
      NOTIFICATION_STATUS.SUCCESS,
    ));
  }, [dispatch]);

  // The full-page form already covers this; do not stack a modal on it.
  const isOnVerifyPage = location?.pathname === ROUTES.APP_VERIFY;

  const isVisible = Boolean(user)
    && telnyxMigrationPin?.required === true
    && !remindLater
    && !isOnVerifyPage;

  if (!isVisible) {
    return null;
  }

  return (
    <ModalDialogMUI6
      isVisible
      onClose={handleRemindLater}
      title={COPY.title}
      titleOptions={{ isCloseIconHid: true }}
      closeOnClickOnlyTheButton
      closeText={COPY.remindLater}
      closeStyleType="white"
      buttonsListOrder={['close']}
      modalSize="sm"
      content={(
        <TelnyxMigrationPinForm
          maskedPhone={telnyxMigrationPin?.maskedPhone || null}
          showTitle={false}
          onVerified={handleVerified}
        />
      )}
    />
  );
}

export default TelnyxMigrationPinModal;
